import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { consultantmage } from "../Constant/Index";

const UserPrescription = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="row">
									<div class="col-lg-12">
										<div class="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img
													src={consultantmage}
													className="img-fluid"
													alt=""
												/>
												<div>
													<h4 class="main-heading-font level-6 ">
														Dr. David Patel
													</h4>
													<h5 class="primary-medium-font level-8 extra-color-15">
														Physician
													</h5>
													<h4 class="primary-medium-font level-7 ">
														<span className="icon-point">
															<i class="fa-solid fa-location-dot"></i>
														</span>{" "}
														Golden Cardiology Center
													</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
											<h4 class="main-heading-font level-6 ">Prescription</h4>
											<p className="extra-color-16">
												Sed ut perspiciatis unde omnis iste natus error sit
												voluptatem accusantium doloremque laudantium, totam rem
												aperiam, eaque ipsa quae ab illo inventore veritatis et
												quasi architecto beatae vitae dicta sunt explicabo. Nemo
												enim ipsam voluptatem quia voluptas sit aspernatur aut
												odit aut fugit, sed quia consequuntur magni dolores eos
												qui ratione voluptatem sequi nesciunt.
											</p>
											<div className="d-flex align-items-center gap-3 mt-2">
												<h4 className="extra-color-16 level-7">
													laudantium otam{" "}
												</h4>
												<h4 className="extra-color-16 level-7">- X2</h4>
											</div>
											<div className="d-flex align-items-center gap-3 mt-2">
												<h4 className="extra-color-16 level-7">rem aperiam </h4>
												<h4 className="extra-color-16 level-7">- X3</h4>
											</div>
											<div className="d-flex align-items-center gap-3 mt-2">
												<h4 className="extra-color-16 level-7">
													veritatis et quasi{" "}
												</h4>
												<h4 className="extra-color-16 level-7">- X4</h4>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-2">
									<div className="col-lg-12">
										<div className="d-flex align-items-center gap-3">
											<Link
												class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												to="/user-prescription-placeorder"
											>
												<span class="bg-wrapper w-100">Buy Now </span>
											</Link>
											<Link
												class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												to="/"
											>
												<span class="bg-wrapper w-100">I’ll Buy on my own</span>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserPrescription;
